(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/views/system-summary.js') >= 0) return;  svs.modules.push('/components/numbergames/game/views/system-summary.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.numbergames=_svs.numbergames||{};
_svs.numbergames.game=_svs.numbergames.game||{};
_svs.numbergames.game.templates=_svs.numbergames.game.templates||{};
svs.numbergames.game.templates.system_summary = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"sytemRowHeaderRegion\"></div>\n<div id=\"sytemBallRowRegion\"></div>\n";
},"useData":true});
Handlebars.partials['components-numbergames-game-system_summary'] = svs.numbergames.game.templates.system_summary;
})(svs, Handlebars);


 })(window);